/** @jsx jsx */

import { capitalize } from 'lodash';

import { Icon } from '@zapier/zinnia-icons';
import { Colors, Text } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import { PublishingSteps, Step } from './PublishingSteps';

const Styles = {
  root: css`
    position: relative;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    min-width: 235px;
    max-width: 400px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 40px;
  `,
  line: (indexStep: number, isCurrent: boolean) => css`
    background-color: transparent;
    position: absolute;
    width: calc((100% - 60px) / 3);
    border-top: 3px ${isCurrent ? 'dashed' : 'solid'} ${Colors.GrayWarm3};
    z-index: 1;
    left: calc(20px + (100% - 60px) / 3 * ${indexStep});
    transform: translateY(46px);
  `,
  progress: css`
    position: relative;
    padding: 0px;
    display: flex;
    justify-content: space-between;
    z-index: 5;
    width: 100%;
  `,
  progressStep: css`
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
  `,
  iconWrapper: css`
    position: relative;
    padding-top: 10px;
  `,
  iconBackground: css`
    position: absolute;
    left: 5px;
    top: 5px;
    z-index: -1;
    background-color: ${Colors.PrimeWhite};
    height: 25px;
    width: 25px;
  `,
  caption: css`
    display: flex;
    align-items: center;
    justify-content: space-around;
    background-color: ${Colors.GrayWarm2};
    border-radius: 10px;
    padding: 10px;
    width: 190px;
  `,
};

type Props = {
  currentStep: Step;
};

export default function Timeline({ currentStep }: Props) {
  const indexCurrent = PublishingSteps.findIndex(
    step => step.status === currentStep.status
  );

  return (
    <figure css={Styles.root}>
      {PublishingSteps.slice(0, -1).map((step, indexStep) => {
        const isCurrent = indexStep === indexCurrent;
        return <hr css={Styles.line(indexStep, isCurrent)} key={step.label} />;
      })}
      <ul css={Styles.progress}>
        {PublishingSteps.map((step, indexStep) => {
          const isCompleted = indexStep <= indexCurrent;

          return (
            <li css={Styles.progressStep} key={step.label}>
              <Text
                color={isCompleted ? 'GrayWarm7' : undefined}
                type="ParagraphHeader3"
              >
                {capitalize(step.label)}
              </Text>
              <div css={Styles.iconWrapper}>
                <span css={Styles.iconBackground} />
                {isCompleted ? (
                  <Icon
                    color="StatusSuccessStronger"
                    name="formCheckCircle"
                    size={35}
                  />
                ) : (
                  <Icon color="GrayWarm4" name="formRadioUnchecked" size={35} />
                )}
              </div>
            </li>
          );
        })}
      </ul>
    </figure>
  );
}
